<script lang="ts">
	import { A } from 'flowbite-svelte';
	import logoImg from '$lib/assets/images/logo.svg';
	import img from './images/404.svg';
	import HeaderMobile from '../layout/header/HeaderMobile.svelte';
</script>

<div class="relative h-[100dvh] text-slate-500 px-5 2xl:px-4">
	<div class="flex flex-col pt-5 2xl:pt-[41.32px] 3xl:pt-[43.75px] 5xl:pt-[48.83px] 6xl:pt-[58px]">
		<div class="hidden 2xl:flex flex-col items-center">
			<A href="/">
				<img
					src={logoImg}
					class="w-[193.517px] 3xl:w-[204px] 5xl:w-[226.667px] 6xl:w-[272px] object-cover"
					alt=""
				/>
			</A>
			<div
				class="flex space-x-[23px] 3xl:space-x-[21px] 5xl:space-x-[25.5px] 6xl:space-x-[27.5px] font-medium text-[11px] 3xl:text-[12px] 5xl:text-[13px] 6xl:text-[16px] mt-[11px] 3xl:mt-[16px] 5xl:mt-[18px] 6xl:mt-[20px]"
			>
				<A href="/news" class="text-inherit !no-underline">Новости</A>
				<A href="/nationalities" class="text-inherit !no-underline">Народы России</A>
				<A href="/religions" class="text-inherit !no-underline">Религии России</A>
				<A href="/calendar?type=events" class="text-inherit !no-underline">Мероприятия</A>
				<A href="/calendar?type=online-translations" class="text-inherit !no-underline">Онлайн</A>
			</div>
		</div>

		<div class="2xl:hidden">
			<HeaderMobile />
		</div>

		<div
			class="relative w-full max-w-[312px] 2xl:max-w-[466px] 3xl:max-w-[492px] 5xl:max-w-[546px] 6xl:max-w-[658px] mx-auto mt-[104px] 2xl:mt-[60px] 3xl:mt-[67px] 5xl:mt-[75px] 6xl:mt-[90px] mb-[35px] 2xl:mb-[70px] 3xl:mb-[71px] 5xl:mb-[80px] 6xl:mb-[96px]"
		>
			<img src={img} class="object-cover" alt="" />
		</div>
		<div
			class="text-center leading-[1.2] max-w-[322px] 2xl:max-w-[422px] 3xl:max-w-[445px] 5xl:max-w-[494px] 6xl:max-w-[593px] mx-auto"
		>
			<div
				class="text-[32px] 2xl:text-[28px] 3xl:text-[30px] 5xl:text-[33px] 6xl:text-[40px] font-semibold mb-[16px] 2xl:mb-[22px] 3xl:mb-[24px] 6xl:mb-[29px] max-w-[190px] 2xl:max-w-none mx-auto"
			>
				Страница не найдена
			</div>
			<div class="text-[14px] 3xl:text-[15px] 5xl:text-[16px] 6xl:text-[20px] font-normal">
				Неправильно набран адрес, или такой страницы на сайте больше не существует.
			</div>
		</div>
	</div>
</div>
